import { useAppContext } from '@contexts/AppContext';
import { Snackbar } from '@material-ui/core';
import React from 'react';

const Notification = () => {
  const { notifications } = useAppContext();
  const [localNotifications, setLocalNotifications] = React.useState(notifications);

  React.useEffect(() => {
    setLocalNotifications(notifications);
  }, [notifications]);

  const handleClose = (id) => {
    setLocalNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  if (localNotifications.length === 0) return null;

  return (
    <>
      {localNotifications.map((notification) => (
        <Snackbar
          key={notification.id}
          open={true}
          autoHideDuration={notification.type === 'error' ? 6000 : 3000}
          onClose={() => handleClose(notification.id)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          message={notification.message}
          role="status"
          aria-live={notification.type === 'error' ? 'assertive' : 'polite'}
          aria-atomic="true"
          action={
            <button
              type="button"
              onClick={() => handleClose(notification.id)}
              aria-label="Close notification"
              className="text-white bg-transparent border-none cursor-pointer p-2 text-lg leading-none opacity-90 transition-opacity duration-200 hover:opacity-100"
            >
              ✕
            </button>
          }
          className={
            notification.type === 'error' ? '!bg-red-500 !text-white' : '!bg-green-500 !text-white'
          }
        />
      ))}
    </>
  );
};

export default Notification;
